import { render, staticRenderFns } from "./ConceptNode.vue?vue&type=template&id=a105f7ea&"
import script from "./ConceptNode.vue?vue&type=script&lang=ts&"
export * from "./ConceptNode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports